<template>
  <card :title="$t('home:lastViewed')" no-body no-footer no-padding class="overflow-hidden">
    <template #card-table>
      <ul class="list-group list-group-flush border-top">
        <li v-if="list.length === 0" class="list-group-item text-muted font-italic text-center">
          {{ emptyMessage | capitalize }}
        </li>

        <router-link v-for="item in list"
                     v-else
                     :key="item.id"
                     :to="item.route"
                     class="list-group-item list-group-item-action"
        >
          {{ item.name || item.id }}
        </router-link>
      </ul>
    </template>
  </card>
</template>

<script>
export default {
  props: {
    // Displayed message when nothing to show
    emptyMessage: {
      type: String,
      required: true
    },
    // List of elements displayed
    list: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .list-group {
    // Fixed height for 5 lines
    height: 219px;
  }
</style>
